import DashboardLayout from "@/components/dashboard/DashboardLayout";
import DashboardMonitorsList from "@/components/monitors/DashboardMonitorsList";
import { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { syncVisitorId } from "@/utils/visitorIdSync";
import { trackSignUp } from "@/utils/analytics";

export default function MonitorsPage() {
  const router = useRouter();
  const signUpTrackedRef = useRef(false);

  useEffect(() => {
    syncVisitorId();
    if (router.isReady && router.query.new_account === "1" && !signUpTrackedRef.current) {
      signUpTrackedRef.current = true;
      const method = (router.query.method as string) || "oauth";
      trackSignUp(method);
      router.replace("/dashboard/monitors", undefined, { shallow: true });
    }
  }, [router.isReady, router.query.new_account, router.query.method, router]);

  return (
    <DashboardLayout
      activePath="/dashboard/monitors"
      title="Monitors"
      breadcrumbs={[{ label: "Monitors" }]}
    >
      <div className="mx-auto max-w-6xl px-4 py-8">
        <DashboardMonitorsList />
      </div>
    </DashboardLayout>
  );
}
